(function () {
  'use strict';

  function init(form) {
    if (form.dataset.discoveryInitialized) return;
    form.dataset.discoveryInitialized = 'true';
    var config = JSON.parse(form.querySelector('[data-discovery-config]').textContent);
    var rows = Array.from(form.querySelectorAll('[data-discovery-fragrance]'));
    var button = form.querySelector('[data-discovery-submit]');
    if (!button) return;
    var label = form.querySelector('[data-discovery-submit-text]');
    var error = form.querySelector('[data-discovery-error]');
    var message = form.querySelector('[data-discovery-message]');
    var selection = form.querySelector('[data-discovery-selection]');
    var summary = form.querySelector('[data-discovery-summary]');
    var properties = form.querySelector('[data-discovery-properties]');
    var quantities = new Map(rows.map(function (row) { return [row.dataset.handle, config.complete ? 1 : 0]; }));
    var italian = config.locale === 'it';
    var busy = false;

    function total() {
      return Array.from(quantities.values()).reduce(function (sum, quantity) { return sum + quantity; }, 0);
    }

    function update() {
      var count = total();
      var remaining = config.size - count;
      button.disabled = busy || !config.available || remaining !== 0;
      if (!config.available) label.textContent = config.soldOut;
      if (config.complete) return;
      form.querySelector('[data-discovery-total]').textContent = String(count);
      form.querySelector('[data-discovery-progress]').style.width = (count / config.size * 100) + '%';
      summary.replaceChildren();
      properties.replaceChildren();
      rows.forEach(function (row) {
        var quantity = quantities.get(row.dataset.handle);
        row.querySelector('[data-discovery-quantity]').textContent = String(quantity);
        row.querySelector('[data-discovery-minus]').disabled = busy || quantity === 0;
        row.querySelector('[data-discovery-plus]').disabled = busy || !config.available || remaining === 0;
        row.classList.toggle('is-selected', quantity > 0);
        if (!quantity) return;
        var item = document.createElement('li');
        item.textContent = row.dataset.name + ' · ' + quantity + ' × 2 ml';
        summary.appendChild(item);
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + row.dataset.name + ']';
        input.value = quantity + ' × 2 ml';
        properties.appendChild(input);
      });
      selection.hidden = count === 0;
      if (remaining === 0) {
        message.textContent = italian ? 'Il tuo kit è completo.' : 'Your set is complete.';
      } else {
        message.textContent = italian
          ? 'Scegli ancora ' + remaining + (remaining === 1 ? ' campione.' : ' campioni.')
          : 'Choose ' + remaining + (remaining === 1 ? ' more sample.' : ' more samples.');
      }
    }

    form.addEventListener('click', function (event) {
      if (event.target.closest('[data-discovery-submit]')) {
        addToCart(event);
        return;
      }
      var control = event.target.closest('[data-discovery-plus], [data-discovery-minus], [data-discovery-reset]');
      if (!control || busy || !config.available) return;
      if (control.hasAttribute('data-discovery-reset')) {
        quantities.forEach(function (_, handle) { quantities.set(handle, 0); });
      } else {
        var row = control.closest('[data-discovery-fragrance]');
        var quantity = quantities.get(row.dataset.handle);
        if (control.hasAttribute('data-discovery-plus') && total() < config.size) {
          quantities.set(row.dataset.handle, quantity + 1);
        } else if (control.hasAttribute('data-discovery-minus') && quantity > 0) {
          quantities.set(row.dataset.handle, quantity - 1);
        }
      }
      error.hidden = true;
      update();
    });

    var search = form.querySelector('[data-discovery-search]');
    if (search) {
      function normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(config.locale).trim();
      }
      search.addEventListener('input', function () {
        var query = normalize(search.value);
        var matches = 0;
        rows.forEach(function (row) {
          var visible = normalize(row.dataset.name).includes(query);
          row.hidden = !visible;
          if (visible) matches++;
        });
        form.querySelector('[data-discovery-no-results]').hidden = matches > 0;
      });
    }

    async function addToCart(event) {
      event.preventDefault();
      if (busy || !config.available) return;
      if (total() !== config.size) {
        message.textContent = italian ? 'Completa la selezione dei ' + config.size + ' campioni.' : 'Complete your selection of ' + config.size + ' samples.';
        return;
      }
      busy = true;
      error.hidden = true;
      label.textContent = italian ? 'Aggiunta in corso…' : 'Adding…';
      form.setAttribute('aria-busy', 'true');
      update();
      // Snapshot all selections before the request; Shopify keeps properties on each kit line.
      try {
        var payload = new FormData(form);
        payload.delete('return_to');
        var response = await fetch(config.addUrl, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: payload });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || (italian ? 'Impossibile aggiungere il kit.' : 'Unable to add your set.'));
        window.location.assign(config.cartUrl);
      } catch (reason) {
        error.textContent = reason.message || (italian ? 'Riprova tra qualche istante.' : 'Please try again in a moment.');
        error.hidden = false;
        busy = false;
        form.removeAttribute('aria-busy');
        label.textContent = config.addLabel;
        update();
      }
    }
    form.addEventListener('submit', addToCart);
    update();
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-discovery-form]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
